import { paths } from './paths'

/**
 * Maps a `/workspaces/:id/...` URL to the flat sidebar menu key.
 * Keys mirror the entries declared in `WORKSPACE_MENU_KEYS`.
 */
export const workspaceSideNavKeyFromPath = (pathname: string): string => {
  const base = `${paths.workspaces.root}/`
  if (!pathname.startsWith(base)) {
    return 'workspaces'
  }
  const rest = pathname.slice(base.length)
  const slash = rest.indexOf('/')
  const id = slash === -1 ? rest : rest.slice(0, slash)
  const tail = slash === -1 ? '' : rest.slice(slash + 1)
  if (!id || id === 'new') {
    return 'workspaces'
  }
  const segment = tail.split('/').filter(Boolean)[0] ?? 'home'

  switch (segment) {
    case '':
    case 'home':
      return 'home'
    case 'overview':
      return 'overview'
    case 'members':
      return 'users'
    case 'organization':
      return 'organization'
    case 'roles':
      return 'roles'
    case 'security':
    case 'sso-scim':
      return 'security'
    case 'apps':
      return 'apps'
    case 'agents':
      return 'agents'
    case 'domains':
      return 'domains'
    case 'public-access':
      return 'publicAccess'
    case 'ai-connectors':
      return 'aiConnectors'
    case 'audit':
      return 'audit'
    case 'graph':
      return 'companyGraph'
    case 'settings':
      return 'workspaceSettings'
    case 'billing':
      return 'billing'
    default:
      return 'home'
  }
}
